export default "__VITE_ASSET__653ecf77__"